module.exports = __webpack_public_path__ + "img/products_big_can_ultimateru.c06c1a4c.png";